<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>买手绑档操作日志</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-select
                    v-if="resData"
                    v-model="form.city"
                    placeholder="城市"
                  >
                    <el-option
                      v-for="(item, index) in city_list"
                      :key="item.label"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.parent_market_id"
                    placeholder="一级市场"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="(item, index) in parent_market_list"
                      :key="item.label"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.action"
                    placeholder="操作方式"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="绑定" value="2"></el-option>
                    <el-option label="解绑" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.action_type"
                    placeholder="绑定/解绑关系"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="核心商家" value="1"></el-option>
                    <el-option label="公共商家" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.picker_group_id"
                    placeholder="买手组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="(item, index) in pg_list"
                      :key="item.label"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.admin_name"
                    placeholder="操作人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="创建时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData.data" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="picker_group_name"
              label="买手组"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="action" label="操作方式" align="center">
            </el-table-column>
            <el-table-column
              prop="action_type"
              label="绑定/解绑关系"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="origin"
              label="城市"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="parent_market_name"
              label="一级市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="操作人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.current_page"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.total"
            :page-size="10"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        create_time: this.defaultDate(),
      },
      loading: false, // 加载动画是否显示
      url: "/erp/PickerGroup/importantSupplyLog",
      status: "",
      curPage: 1,
      filterFold: false,
      pg_list: [],
      parent_market_list: [],
      city_list: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.pg_list = this.resData.pg_list;
          this.parent_market_list = this.resData.parent_market_list;
          this.city_list = this.resData.city_list;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    search() {
      this.fetchData();
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/ImportantSupplyLog.vue